import React, { useEffect, useState } from 'react';
import * as K from '@app/components/Dashboard/Clock/DashboardClock.styles';
import { BaseCard } from '@app/components/common/BaseCard/BaseCard';
import * as S from './Clock.styles';
import { Dates } from '@app/constants/Dates';

export const DashBoardClockDigital: React.FC = () => {
  const [dateState, setDateState] = useState(new Date());

  const currentDateInUTC = dateState.toUTCString();
  const currentTime = Dates.format(currentDateInUTC, 'h:mm A');
  const currentDate = Dates.format(currentDateInUTC, 'dddd, MMMM D, YYYY');

  useEffect(() => {
    const interval = setInterval(() => setDateState(new Date()), 10 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <K.Wrapper>
      <BaseCard padding={'10px'}>
        <S.ContentWrapper>
          <S.Time>{currentTime}</S.Time>
          <S.Date>{currentDate}</S.Date>
        </S.ContentWrapper>
      </BaseCard>
    </K.Wrapper>
  );
};
